import { useContext, useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, InsertDateFormat, SettlementPaymentStatusOptions, StatusCodeDelete } from "utils/Constant"
import moment from "moment";
import DatePicker from "components/Input/DatePicker";
import { addSpaceEvery4, money, Truncate } from "utils/helpers";
import Dropdown from "components/Input/Dropdown";
import { useCallApi } from "api/apiHooks";
import { FilterCard, FormCard, GridDeleteButton, GridEditButton, MainBodyCard, PagesTitle } from "components/Cards";
import SmallButton from "components/Button/SmallButton";
import { useModal } from "utils/context/ModalContext";
import EditIcon from "assets/icon/EditIcon";
import CheckCircleIcon from "assets/icon/CheckCircleIcon";
import Select from 'react-select'
import TrashIcon from "assets/icon/TrashIcon";
import PrintButton from "components/Button/PrintButton";
import { PelunasanReportService } from "reportServices/PelunasanReportService";
import DataTable from "components/DataTable";
import { useVariable } from "utils/context/VariableContext";

export default function Pelunasan(){
    let navigate = useNavigate()

    const { locationId, isAdmin, transferSourceOptions } = useVariable()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchSettlementList, fetchPaySettlement, fetchSettlementTransaction, fetchDeleteSettlement } = useCallApi()

    const firstLoad = useRef(true)
    const debounceRef = useRef(null)

    const [settlementList, setSettlementList] = useState([])
    const [settlementDate, setSettlementDate] = useState(new Date())
    const [customerName, setCustomerName] = useState('')
    const [cardNumber, setCardNumber] = useState('')
    const [status, setStatus] = useState('1')
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(SettlementPaymentStatusOptions[0].value)
    const [showModal, setShowModal] = useState(false)
    const [selectedTransferSource, setSelectedTransferSource] = useState('')
    const [selectedSettlement, setSelectedSettlement] = useState({})
    const [unpaidSettlementCount, setUnpaidSettlementCount] = useState(0)

    const handleCopyBtnClick = (text) => {
        navigator.clipboard.writeText(text)
    }
    const paymentBtnClick = (data) => {
        setSelectedSettlement(data)
        setShowModal(true)
    }
    const transactionBtnClick = async (id) => {
        const isConfirm = await confirm()

        if (isConfirm) {
            showLoading()

            try {
                const res = await fetchSettlementTransaction(id)

                if (!res) return
            } finally {
                hideLoading()
                showSuccess({
                    onSuccess: async () => {
                        showLoading()

                        try {
                            getSettlementList()
                        } finally {
                            hideLoading()
                        }
                    }
                })
            }
        }
    }
    const proceedPaymentBtnClick = async (settlementId, transferSourceId, payCustomerPayment, paymentStatus, billingAmount, customerPayment, otherFee) => {
        const isConfirm = await confirm()

        if (isConfirm) {
            showLoading()

            try {
                const res = await fetchPaySettlement(settlementId, transferSourceId, payCustomerPayment, paymentStatus, billingAmount, customerPayment, otherFee)

                if (!res) return
            } finally {
                hideLoading()
                showSuccess({
                    onSuccess: async () => {
                        showLoading()

                        try {
                            getSettlementList()
                        } finally {
                            hideLoading()
                        }
                    }
                })
            }
        }
    }
    const deleteBtnClick = async (id, status) => {
        const isConfirm = await confirm()

        if (isConfirm) {
            showLoading()

            try {
                const res = await fetchDeleteSettlement(id, status)

                if (!res) return
            } finally {
                hideLoading()
                showSuccess({
                    onSuccess: async () => {
                        showLoading()

                        try {
                            await getSettlementList()
                        } finally {
                            hideLoading()
                        }
                    }
                })
            }
        }
    }
    const printBtnClick = async () => {
        PelunasanReportService(settlementList, settlementDate)
    }

    const getSettlementList = async () => {
        const res = await fetchSettlementList(
            customerName,
            cardNumber,
            selectedPaymentStatus,
            moment(settlementDate).format(InsertDateFormat),
            status
        )

        if (!res) return

        setUnpaidSettlementCount(res.data.unpaidSettlement)
        setSettlementList(res.data.listData)
    }

    useEffect(() => {
        let loadData = async () => {
            showLoading()

            try {
                if (firstLoad.current) {
                    await getSettlementList()

                    firstLoad.current = false
                } else {
                    if (debounceRef.current) {
                        clearTimeout(debounceRef.current)
                    }
            
                    debounceRef.current = setTimeout(async () => {
                        await getSettlementList()
                    }, 500)
                }
            } finally {
                hideLoading()
            }
        }

        loadData()
    }, [settlementDate, status, customerName, cardNumber, selectedPaymentStatus])

    return(
        <MainBodyCard>
            <PagesTitle title={'Pelunasan'} />
            
            {/* FILTER */}
            <div className="flex flex-col sm:flex-row sm:gap-4 gap-2 sm:mt-3">
                <FilterCard title='Tanggal Pelunasan'>
                    <DatePicker className='w-full h-10' value={settlementDate} onChange={setSettlementDate} />
                </FilterCard>
                <FilterCard title='Nama Pelanggan'>
                    <input className="input" value={customerName} onChange={(e) => { setCustomerName(e.target.value) }} />
                </FilterCard>
                <FilterCard title='No Kartu'>
                    <input className="input" value={cardNumber} onChange={(e) => { setCardNumber(e.target.value) }} />
                </FilterCard>
                <FilterCard title='Status' width={'w-full sm:w-32'}>
                    <Dropdown className='w-full' options={DropdownStatusList} value={status} onChange={(e) => { setStatus(e.value) }} placeholder='All' />
                </FilterCard>
            </div>

            {isAdmin && 
                <div className="mt-3 flex gap-3 justify-end">
                    <button className="button">
                        <span>Riwayat Pelunasan</span>
                    </button>
                    <PrintButton onClick={printBtnClick} />
                </div>
            }
           
            {/* STATUS BAR */}
            <div className="mt-3 flex flex-col sm:flex-row justify-between items-center sm:border py-2 xl:px-2 bg-white rounded-full">
                <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
                    <div className="flex items-center gap-2 flex-wrap ">
                        { SettlementPaymentStatusOptions.map((data, i) => {
                            return (
                                <button 
                                    className={`${selectedPaymentStatus === data.value ? 'bg-black text-white' : 'bg-white text-black'} border rounded-full px-3 py-1 text-xs`}
                                    onClick={() => { setSelectedPaymentStatus(data.value) }}
                                    key={i}    
                                >
                                    { data.label }
                                </button>
                            )
                        })}
                    </div>

                    <div className="hidden sm:flex gap-2 flex-wrap">
                        <div className="border bg-red-500 px-3 py-1 rounded-full text-xs text-white">
                            <span>Belum Dibayar : </span>
                            <span>
                                { unpaidSettlementCount }
                            </span>
                        </div>
                    </div>
                </div>
                
                <div className="flex flex-1 w-full justify-end mt-2 sm:mt-0">
                    <SmallButton 
                        title='Tambah Pelunasan'
                        onClick={() => { navigate('/pelunasan/form?formType=Add&settlementId=') }}
                    />
                </div>
            </div>
            
            {/* TABLE FOR WIDESCREEN */}
            <div className="mt-3 w-full hidden xl:block rounded-md">
                <table className="w-full border bg-white text-md font-light text-sm rounded-md">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-12">No</th>
                            <th className="font-semibold text-left px-1">Nama Pelanggan</th>
                            <th className="font-semibold text-left px-1">Bank</th>
                            <th className="font-semibold text-left px-1">Nomor Kartu</th>
                            <th className="font-semibold text-left px-1">MDR</th>
                            <th className="font-semibold text-center px-1">JT</th>
                            <th className="font-semibold text-left px-1">Status Bayar</th>
                            <th className="font-semibold text-left px-1"></th>
                            <th className="font-semibold text-left px-1">Tagihan</th>
                            <th className="font-semibold text-left px-1">Titipan</th>
                            <th className="font-semibold text-left px-1">Biaya Lain</th>
                            <th className="font-semibold text-left px-1">Gesek Lagi</th>
                            <th className="font-semibold text-left px-1">Status Gesek</th>
                            <th className="font-semibold text-left px-1">TF Source</th>
                            <th className="font-semibold text-left px-1">Remark</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    {settlementList?.length > 0 ? 
                        <tbody className="border">
                            {settlementList?.map((data, i) => {
                                return(
                                    <tr className={`my-2 row border-y hover:bg-slate-100 ${String(data.locationId) === '2' ? 'text-blue-500' : ''}`} key={ i }>
                                        <td className="text-center">{ data.rowNumber }</td>

                                        <td className="px-2">
                                            <span>
                                                {data.customerName.length > 12
                                                ? data.customerName.slice(0, 12).toUpperCase() + "..." 
                                                : data.customerName.toUpperCase()}
                                            </span>
                                        </td>

                                        <td className="px-2">
                                            <span>{ data.bankCode }</span>
                                        </td>

                                        <td className="px-2 text-nowrap">
                                            { data.virtualAccountNo === data.cardNumber ? 
                                                <button onClick={() => handleCopyBtnClick(data.virtualAccountNo)}>
                                                    <span>{ addSpaceEvery4(data.virtualAccountNo) }</span> 
                                                </button>
                                            : 
                                            <div className="flex flex-col">
                                                <button onClick={() => handleCopyBtnClick(data.virtualAccountNo)}>
                                                    <span>{ addSpaceEvery4(data.virtualAccountNo) }</span>
                                                </button>                                                
                                                <span className="line-through">{ addSpaceEvery4(data.cardNumber) }</span>
                                            </div>
                                            }
                                            
                                        </td>

                                        <td className="px-2">
                                            <span>{ data.mdr }</span>
                                        </td>

                                        <td className="px-2">
                                            <span>{ moment(data.dueDate).format('D/M') }</span>
                                        </td>

                                        <td className="px-2">
                                            <div className="flex items-center gap-2 text-nowrap">
                                                <div className="flex flex-col">
                                                    <span className={`${data.paymentStatus === '2' ? 'font-normal line-through' : 'font-semibold'}`}>
                                                        { data.payCustomerPayment === '1' ? 'Bayar Titipan Dulu' : '' }
                                                    </span>
                                                    <span className={`${data.paymentStatus === '2' ? 'font-semibold' : 'font-normal'}`}>
                                                        { SettlementPaymentStatusOptions.find(x => x.value === data.paymentStatus).label  }
                                                    </span>
                                                </div>
                                            </div>
                                        </td>

                                        <td className="px-2">
                                            <div className="flex items-center gap-2 text-nowrap">                                                
                                                { data.paymentStatus !== '2' && 
                                                    <button className="bg-black rounded-full p-1"
                                                        onClick={ () => paymentBtnClick(data) }
                                                    >
                                                        <CheckCircleIcon className="fill-white w-4" />
                                                    </button>
                                                }
                                            </div>
                                        </td>

                                        <td className="px-2 text-nowrap">
                                            <div className="flex flex-col">
                                                <span 
                                                    className={`
                                                        ${data.paymentStatus === '0' && 
                                                            data.payCustomerPayment === '2' ? 'font-semibold' : ''
                                                        }
                                                        ${data.paymentStatus === '1' ? 'line-through' : ''}
                                                    
                                                    `}
                                                >
                                                    Rp { money(data.billingAmount) }
                                                </span>
                                                { data.payCustomerPayment === '1' && data.paymentStatus === '1' &&
                                                    <span
                                                        className="font-semibold"
                                                    >
                                                        Rp { money(data.billingAmount - (data.customerPayment - data.otherFee)) }
                                                    </span>
                                                }
                                            </div>
                                        </td>

                                        <td className="px-2">
                                            <span
                                                className={`${data.paymentStatus === '0' && 
                                                    data.payCustomerPayment === '1' ? 'font-semibold' : ''
                                                }`}
                                            >Rp { money(data.customerPayment - data.otherFee) }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>Rp { money(data.otherFee) }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>Rp { money(data.transactionAmount) }</span>
                                        </td>
                                        <td className="px-2">
                                            <div className="flex items-center gap-2">
                                                <span>{ data.isTransaction === '0' ? 'Belum Gesek' : 'Sudah Gesek' }</span>
                                                {
                                                    data.paymentStatus === '2' && data.isTransaction === '0' &&
                                                        <button className="bg-black rounded-full p-1"
                                                            onClick={ () => transactionBtnClick(data.settlementId) }
                                                        >
                                                            <CheckCircleIcon className="fill-white w-4" />
                                                        </button>
                                                }
                                            </div>
                                        </td> 
                                        <td className="px-2">
                                            <span>{ 
                                            data.transferSourceId !== 0 ? 
                                            (
                                                transferSourceOptions.find(x => x.value === String(data.transferSourceId)).label.length > 12 ? 
                                                transferSourceOptions.find(x => x.value === String(data.transferSourceId)).label.slice(0, 12).toUpperCase() + "..." : 
                                                data.customerName.toUpperCase()
                                            ) : 
                                            '-' }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.remark }</span>
                                        </td>
                                        <td className="py-2 px-2">
                                            <div className="flex gap-2">
                                                <button className={`p-2 bg-black rounded-lg flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} 
                                                    onClick={() => navigate('/pelunasan/form?formType=Edit&settlementId=' + String(data.settlementId) )}
                                                >
                                                    <EditIcon className="w-3 fill-white" />
                                                </button>
                                                <button className={`p-2 bg-black rounded-lg flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} 
                                                    onClick={() => deleteBtnClick(data.settlementId, data.status)}
                                                >
                                                    <TrashIcon className="w-3 fill-white" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    :
                        <tbody>
                            <tr className="h-10">
                                <td className="text-center" colSpan={14}>
                                    <span>No Transaction Data</span>
                                </td>
                            </tr>
                        </tbody>
                    }
                    <tfoot>
                        <tr className="h-12">
                            <th colSpan={8} className="font-semibold text-right px-2">Total</th>
                            <th colSpan={3} className="font-semibold text-left px-2">Rp { money(settlementList.reduce((total, item) => total + item.billingAmount, 0)) }</th>
                            <th colSpan={3}></th>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {/* MOBILE VERSION */}
            <div className="block xl:hidden">
                {settlementList?.length > 0 ? 
                    <div className="text-sm tracking-wide">
                        {settlementList?.map((data, i) => {
                            return(
                                <div className="flex flex-col">
                                    <div className="flex ">
                                        <span>{ data.customerName }</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <button onClick={() => handleCopyBtnClick(data.virtualAccountNo)}>
                                            <span>{ addSpaceEvery4(data.virtualAccountNo) }</span>
                                        </button>
                                        <span>
                                            { data.bankCode }
                                        </span>
                                    </div>
                                    <div className="flex justify-between">
                                        <div className="flex flex-col">
                                            <span 
                                                className={`
                                                    ${data.paymentStatus === '0' && 
                                                        data.payCustomerPayment === '2' ? 'font-semibold' : ''
                                                    }
                                                    ${data.paymentStatus === '1' ? 'line-through' : ''}    
                                                `}
                                            >
                                                Billing: Rp { money(data.billingAmount) }
                                            </span>
                                            { data.payCustomerPayment === '1' && data.paymentStatus === '1' &&
                                                <span
                                                    className="font-semibold"
                                                >
                                                    Billing: Rp { money(data.billingAmount - (data.customerPayment - data.otherFee)) }
                                                </span>
                                            }
                                        </div>

                                        <div className="flex items-center gap-2 text-nowrap">
                                            <div className="flex flex-col text-right">
                                                <span className={`${data.paymentStatus === '2' ? 'font-normal line-through' : 'font-semibold'}`}>
                                                    {data.payCustomerPayment === '1' ? 'Bayar Titipan Dulu' : ''}
                                                </span>
                                                <span className={`${data.paymentStatus === '2' ? 'font-semibold' : 'font-normal'}`}>
                                                    {SettlementPaymentStatusOptions.find(x => x.value === data.paymentStatus).label}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex justify-between">
                                        <span 
                                            className={`
                                                ${data.paymentStatus === '0' && 
                                                    data.payCustomerPayment === '1' ? 
                                                    'font-semibold' : ''
                                                }`}
                                        >
                                            Titipan: Rp { money(data.customerPayment - data.otherFee) }
                                        </span>

                                        <div className="flex items-center gap-2">
                                            <span>{ data.isTransaction === '0' ? 'Belum Gesek' : 'Sudah Gesek' }</span>
                                            
                                        </div>
                                    </div>   
                                    
                                    { data.paymentStatus !== '2' && 
                                        <button className="bg-black rounded-full p-1 px-4 mt-2 flex gap-2 justify-center"
                                            onClick={ () => paymentBtnClick(data) }
                                        >
                                            <CheckCircleIcon className="fill-white w-4" />
                                            <span className="text-white">Payment</span>
                                        </button>
                                    }

                                    { data.paymentStatus === '2' && data.isTransaction === '0' &&
                                        <button className="bg-black rounded-full p-1 flex gap-2"
                                            onClick={ () => transactionBtnClick(data.settlementId) }
                                        >
                                            <CheckCircleIcon className="fill-white w-4" />
                                            <span>Gesek</span>
                                        </button>
                                    }
                                    <hr className="my-4" /> 
                                </div>
                            )
                        })}
                    </div>
                :
                    <tbody>
                        <tr className="h-10">
                            <td className="text-center" colSpan={14}>
                                <span>No Transaction Data</span>
                            </td>
                        </tr>
                    </tbody>
                }
            </div>
            
            {/* MODAL AFTER SUBMIT */}
            {showModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                
                {/* BACKDROP */}
                <div
                    className="absolute inset-0 bg-black/50"
                    onClick={() => setShowModal(false)}
                />

                {/* MODAL BOX */}
                <div className="relative overflow-auto bg-white rounded-xl shadow-lg w-full lg:w-9/12 xl:w-8/12 2xl:w-6/12 p-6 xl:min-h-[60vh] max-h-[90vh] overflow-y-auto">
                    <h2 className="text-xl font-semibold mb-3">Confirm Payment</h2>

                    <FormCard title='Nama Pelanggan'>
                        <span>{ selectedSettlement.customerName }</span>
                    </FormCard>
                    <FormCard title='No Kartu'>
                        <span>{ addSpaceEvery4(selectedSettlement.virtualAccountNo) }</span>
                    </FormCard>
                    <FormCard title='Bank'>
                        <span>{ selectedSettlement.bankCode }</span>
                    </FormCard>
                    <FormCard title='Tagihan'>
                        <span>Rp { money(selectedSettlement.billingAmount) }</span>
                    </FormCard>
                    <FormCard title='Biaya Lain'>
                        <span>Rp { money(selectedSettlement.otherFee) }</span>
                    </FormCard>
                    <FormCard title='Titipan'>
                        <span>Rp { money(selectedSettlement.customerPayment - selectedSettlement.otherFee) }</span>
                    </FormCard>
                    <FormCard title='Source Transfer'>
                        <Select
                            value={selectedTransferSource}
                            options={transferSourceOptions}
                            onChange={(option) =>
                                setSelectedTransferSource(option)
                            }
                        />
                    </FormCard>
                    
                    <div className="flex justify-end gap-3 mt-6">
                        <button
                            className="px-4 py-2 rounded-full border"
                            onClick={() => setShowModal(false)}
                        >
                            Cancel
                        </button>

                        <button
                            className="px-4 py-2 rounded-full bg-black text-white "
                            onClick={() => {
                                proceedPaymentBtnClick(
                                    selectedSettlement.settlementId, 
                                    selectedTransferSource.value, 
                                    selectedSettlement.payCustomerPayment,
                                    selectedSettlement.paymentStatus,
                                    selectedSettlement.billingAmount,
                                    selectedSettlement.customerPayment,
                                    selectedSettlement.otherFee
                                );
                                setShowModal(false);
                            }}
                        >
                            Confirm
                        </button>
                    </div>
                </div>
                </div>
            )}
        </MainBodyCard>
    )
}
